// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5621":"3871308180958fc73734","8930":"692fe05329c004571338","9561":"6a2fb74f585543f9dc8a"}[chunkId] + ".js";
};